import React from 'react';
import PropTypes from 'prop-types';

import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

import {getConfigByContext} from '#core/utils/config-utils.js';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

const {dispatch} = MojitoCore.Services.redux.store;

const IntentTypes = MojitoPresentation.Base.Intent.Types;
const IntentActions = MojitoCore.Intents.actions;
const UIView = MojitoCore.Presentation.UIView;

class SimpleIconImpl extends UIViewImplementation {
    render() {
        const config = this.style;

        let onClick = null;
        if (config.intent) {
            onClick = () => dispatch(IntentActions.publishIntent(config.intent.type, config.intent.data));
        } else if (config.url) {
            onClick = () => this.openUrl(config.url, config.windowName);
        }

        return (
            <img
                src={config.icon}
                alt={config.alt}
                key={config.icon}
                className={this.props.className || config.taId}
                {...(config.disableStyleHeightWidth && {height: config.height, width: config.width})}
                style={
                    config.disableStyleHeightWidth
                        ? {margin: config.margin}
                        : {width: config.width, height: config.height, margin: config.margin, ...config.iconStyle}
                }
                onClick={onClick}
                loading={'lazy'}
            />
        );
    }

    openUrl(url, windowName) {
        if (windowName != null) {
            dispatch(IntentActions.publishIntent(IntentTypes.OPEN_URL, {url: url, windowName: windowName}));
        } else {
            dispatch(IntentActions.publishIntent(IntentTypes.OPEN_URL, {url: url}));
        }
    }
}

SimpleIconImpl.propTypes = {
    className: PropTypes.string,
};

SimpleIconImpl.getStyle = (config, mode, merge) => {
    config = getConfigByContext(config, mode);

    return merge(
        {
            iconStyle: {
                minWidth: config.width,
                minHeight: config.height,
            },
        },
        config
    );
};

// Most of the parameters is passing via config.
// Application context is taken into account.
// Config has the following structure:
// {
//   icon: PropTypes.string.isRequired,
//   alt: PropTypes.string,
//   width: PropTypes.int,
//   height: PropTypes.int,
//
//   intent: PropTypes.object,
//   url: PropTypes.string,
//   windowName: PropTypes.string,
//   taId: PropTypes.string,
//
//   iconStyle: PropTypes.object,
// }
export const SimpleIcon = UIView('SimpleIcon', SimpleIconImpl, SimpleIconImpl.propTypes);
